module.exports = __webpack_public_path__ + "img/bg-compliance-4.6c538800.png";